import { EditPostPageDocument } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import NotFound from 'modules/core/components/NotFound'
import { useQuery } from 'modules/core/hooks/useQuery'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import ManagePost from 'modules/posts/components/ManagePost'

const EditPostPage = () => {
  const { id } = useStrictParams<'id'>()
  const { loading, data, error } = useQuery(EditPostPageDocument, { variables: { id: String(id) } })

  const post = data?.posts.post

  return (
    <ResponsivePage.Body
      authorized={post?._policies?.manage.can}
      variant="full"
      loading={loading}
      error={error}
      showHeader={false}
    >
      {post ? <ManagePost post={post} /> : <NotFound />}
    </ResponsivePage.Body>
  )
}

export default observer(EditPostPage)
